// @flow

import * as React from "react";
import { format, parse, isValid } from "date-fns";

import { monthPickerFormFormat } from "../../../utils/formats";
import TextInput, { type InputType } from "../../Input/TextInput";

type NativeMonthPickerProps = {
  input: InputType,
  minDate: Date,
  maxDate: Date,
  placeholder: string
};

const nativeDatePickerFormat = "yyyy-MM";

const handleOnChange = (e: Event, input) => {
  if (e.target instanceof HTMLInputElement) {
    const newDate = parse(e.target.value, nativeDatePickerFormat, new Date());

    input.onChange(isValid(newDate) ? format(newDate, monthPickerFormFormat) : null);
  }
};

const NativeMonthPicker = ({ input, minDate, maxDate, placeholder }: NativeMonthPickerProps) => {
  const date = parse(input.value, monthPickerFormFormat, new Date());

  return (
    <TextInput
      input={{
        ...input,
        // it's so complicated, because of possibility to change format of a stored date
        value: isValid(date) ? format(date, nativeDatePickerFormat) : "",
        onChange: (e: Event) => handleOnChange(e, input)
      }}
      onKeyDown={(e: KeyboardEvent) => e.preventDefault()}
      type="month"
      min={format(minDate, nativeDatePickerFormat)}
      max={format(maxDate, nativeDatePickerFormat)}
      placeholder={placeholder}
    />
  );
};

export default NativeMonthPicker;
